import script from "./Address.vue?vue&type=script&setup=true&lang=ts"
export * from "./Address.vue?vue&type=script&setup=true&lang=ts"

import "./Address.vue?vue&type=style&index=0&id=012f2573&scoped=true&lang=less"

import exportComponent from "/data/liulv-h5/International-card-h5/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-012f2573"]])

export default __exports__